import ContestLayout from '../views/ContestLayout.vue'
import ContestHome from '../views/ContestHome.vue'

export default [
  {
    path: '/contest/login',
    redirect: {
      path: '/contest/home',
      query: { from: 'login' }
    }
  },
  {
    path: '/contest',
    component: ContestLayout,
    redirect: '/contest/home',
    children: [
      {
        path: 'home',
        name: 'ContestHome',
        component: ContestHome
      },
      {
        path: 'square',
        redirect: {
          path: '/contest/home',
          query: { from: 'square' }
        }
      },
      {
        path: 'ranking',
        redirect: {
          path: '/contest/home',
          query: { from: 'ranking' }
        }
      },
      {
        path: 'detail/:id',
        redirect: {
          path: '/contest/home',
          query: { from: 'detail' }
        }
      },
      {
        path: 'user-center',
        redirect: {
          path: '/contest/home',
          query: { from: 'user-center' }
        }
      },
      {
        path: 'my-submissions',
        redirect: {
          path: '/contest/home',
          query: { from: 'my-submissions' }
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/contest/router/index.js